export default {
  "freeSpinRecord.thead.freeSpinBonusId": "免费旋转奖励ID",
  "freeSpinRecord.thead.userno": "用户编号",
  "freeSpinRecord.thead.email": "邮箱",
  "freeSpinRecord.thead.name": "姓名",
  "freeSpinRecord.thead.firstName": "名",
  "freeSpinRecord.thead.lastName": "姓",
  "freeSpinRecord.thead.betAmount": "投注金额",
  "freeSpinRecord.thead.spin": "旋转次数",
  "freeSpinRecord.thead.useSpin": "已使用旋转",
  "freeSpinRecord.thead.bonusAmount": "奖励金额",
  "freeSpinRecord.thead.chanceType": "机会类型",
  "freeSpinRecord.thead.createTime": "创建时间",
  "freeSpinRecord.thead.expireTime": "过期时间",
  "freeSpinRecord.title": "免费旋转记录",
};
